import { Anchor, Checkbox, Text } from "@mantine/core";
import { HiCheck } from "react-icons/hi";
import { useTranslation } from "react-i18next";

interface IProps {
  isConfirmThatYouRead: boolean | undefined;
  handleConfirmThatYouRead: () => void;
  text: string;
}

export default function ConfirmThatYouRead({
  isConfirmThatYouRead = false,
  handleConfirmThatYouRead,
  text,
}: IProps) {
  const { t } = useTranslation();

  return (
    <Checkbox
      color="primary.1"
      size="md"
      icon={HiCheck}
      onChange={handleConfirmThatYouRead}
      checked={isConfirmThatYouRead}
      label={<Text fw={600}>{t(text)}</Text>}
      styles={{
        root: { height: "fit-content" },
        body: { height: "fit-content", alignItems: "start" },
      }}
    />
  );
}
